import React, { MouseEventHandler, ReactNode } from "react";
import styles from "./styles.module.sass";
import cx from "classnames";
import { Link } from "react-router-dom";

interface ButtonProps {
  buttonVariant?: "contrast" | "frameless";
  active?: boolean;
  disabled?: boolean;
  children?: ReactNode;
  clickHandler?: MouseEventHandler<HTMLDivElement>;
  to?: string;
  size?: "base" | "small" | "large";
  className?: string;
  comingSoon?: boolean;
  href?: string;
}

const Button: React.FC<ButtonProps> = ({
  buttonVariant = "contrast",
  active = false,
  disabled = false,
  children,
  clickHandler,
  to,
  size = "base",
  className,
  comingSoon = false,
  href = "",
}) => {
const classes = cx(
  styles.button,
  styles[buttonVariant],
  styles[size],
  className,
  {
    [styles.isActive]: active,
    [styles.isDisabled]: disabled,
    [styles.isComingSoon]: comingSoon,
  }
);


  const Wrapper: any = to ? Link : "div";
  const Anchor: any = href ? "a" : "div";

  if (href) {
    return (
      <Anchor href={href} className={classes} target="_blank" rel="noopener noreferrer">
        {children}
      </Anchor>
    );
  }

  return (
    <Wrapper to={to} className={classes} onClick={clickHandler}>
      {children}
    </Wrapper>
  );
};

export default Button;
